import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'al-content-divider',
    template: `
        <div class="{{arrowClass}} {{contentDividerBrand}}" [class.al-container]="!isPlaceholder" attr.data-contentDivider-type="{{contentDividerType}}">
            <div class="al-container-content">
                <ng-content></ng-content>
            </div>
        </div>
    `
})

export class AlContentDividerComponent implements OnInit {

    // Set arrow class with position
    public arrowClass: string;

    // Type of content devider like Content Divider without Arrow, Content Divider with Arrow, Upper, Lower
    @Input() contentDividerType: string;

    // Brand class
    @Input() contentDividerBrand: string;

    // Has pointer arrow. Provide true if need arrow
    @Input() hasArrow: boolean = false;

    // Set arrow position
    @Input() arrowPosition: string = 'top-left';

    // Set placeholder if needed
    @Input() isPlaceholder: boolean = false;

    ngOnInit() {
        // Add CSS class to display arrow for content-devider if hasArrow = true
        if (this.hasArrow && this.arrowPosition) {
            this.arrowClass = 'arrow-box has-arrow-' + this.arrowPosition;
        }
    }

}
